module.exports = __webpack_public_path__ + "assets/img/08-l.46cac7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/08-l.jpg
// module id = N10u
// module chunks = 0